/* No More homepage signup -- Turnstile-gated proxy to hub.nomorecocktails.shop */
(function(){
  /* ═══ TURNSTILE BOOTSTRAP for homepage signup ═══ */
  var nmSignupLoadedAt = Date.now();
  var nmSignupTurnstileToken = '';
  var nmSignupTurnstileWidgetId = null;
  var NM_SIGNUP_TURNSTILE_SITE_KEY = '0x4AAAAAADJyzPAYftR5r0WY';
  window.__nmSignupTurnstileReady = function() {
    if (!window.turnstile) return;
    var container = document.getElementById('nm-signup-turnstile');
    if (!container) return;
    try {
      nmSignupTurnstileWidgetId = window.turnstile.render('#nm-signup-turnstile', {
        sitekey: NM_SIGNUP_TURNSTILE_SITE_KEY,
        action: 'homepage_signup',
        appearance: 'interaction-only',
        callback: function(t) { nmSignupTurnstileToken = t; },
        'error-callback': function() { nmSignupTurnstileToken = ''; },
        'expired-callback': function() {
          nmSignupTurnstileToken = '';
          if (window.turnstile && nmSignupTurnstileWidgetId !== null) {
            try { window.turnstile.reset(nmSignupTurnstileWidgetId); } catch (_) {}
          }
        }
      });
    } catch (_) { /* fail-quiet */ }
  };
  (function() {
    if (document.querySelector('script[src*="turnstile/v0/api.js"]')) {
      // Already loaded by another section (e.g. quiz). Render directly.
      if (window.turnstile) window.__nmSignupTurnstileReady();
      return;
    }
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=__nmSignupTurnstileReady&render=explicit';
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
  })();

  // Interaction counters (2026-07-11): real humans move pointers. The server
  // quarantines tokenless submissions that show interaction instead of
  // dropping them, so these signals are what keep a Turnstile outage from
  // silently costing leads.
  var nmSignupPointerMoves = 0;
  var nmSignupKeystrokes = 0;
  document.addEventListener('pointermove', function () { nmSignupPointerMoves++; }, { passive: true });
  document.addEventListener('touchstart', function () { nmSignupPointerMoves++; }, { passive: true });
  document.addEventListener('keydown', function (e) {
    if (e.key && e.key.length === 1) nmSignupKeystrokes++;
  });

  function nmKlaviyoSubscribe(e) {
    e.preventDefault();
    var firstName = (document.getElementById('nm-signup-fname').value || '').trim();
    var lastName = (document.getElementById('nm-signup-lname').value || '').trim();
    var email = (document.getElementById('nm-signup-email').value || '').trim();
    var honeypot = (document.getElementById('nm-signup-hp').value || '').trim();
    var btn = document.getElementById('nm-signup-btn');
    var fine = document.querySelector('.nm-signup-fine');
    if (!firstName || !lastName || !email) {
      fine.textContent = 'Please fill in your name and email.';
      return false;
    }
    btn.textContent = '...';
    btn.disabled = true;
    // Fail-safe (2026-07-11): wait briefly for a Turnstile token but NEVER
    // refuse to submit. Tokenless submissions are quarantined server-side
    // instead of lost (the May 2026 quiz bug class).
    var nmAttempts = 0;
    (function nmWaitAndSend() {
      if (!nmSignupTurnstileToken && nmAttempts < 50) {
        nmAttempts++;
        setTimeout(nmWaitAndSend, 100);
        return;
      }
      nmDoSend();
    })();
    function nmDoSend() {
    fetch('https://hub.nomorecocktails.shop/public/list-subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        turnstile_token: nmSignupTurnstileToken,
        first_name: firstName,
        last_name: lastName,
        email: email,
        list_id: 'W3Jfzx',
        custom_source: 'Homepage Signup',
        signals: {
          time_ms: Date.now() - nmSignupLoadedAt,
          honeypot: honeypot,
          pointer_moves: nmSignupPointerMoves,
          keystrokes: nmSignupKeystrokes
        }
      })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('rejected');
      return r.json();
    })
    .then(function() {
      btn.textContent = '\u2713';
      fine.textContent = 'You are in. Welcome to No More.';
      document.getElementById('nm-signup-fname').value = '';
      document.getElementById('nm-signup-lname').value = '';
      document.getElementById('nm-signup-email').value = '';
    })
    .catch(function() {
      btn.textContent = 'Join';
      btn.disabled = false;
      fine.textContent = 'Something went wrong. Try again.';
      if (window.turnstile && nmSignupTurnstileWidgetId !== null) {
        try { window.turnstile.reset(nmSignupTurnstileWidgetId); nmSignupTurnstileToken = ''; } catch (_) {}
      }
    });
    }
    return false;
  }
  window.nmKlaviyoSubscribe = nmKlaviyoSubscribe;
})();
